import { render, staticRenderFns } from "./Costo.vue?vue&type=template&id=eb9f8732&scoped=true"
import script from "./Costo.vue?vue&type=script&lang=js"
export * from "./Costo.vue?vue&type=script&lang=js"
import style0 from "./Costo.vue?vue&type=style&index=0&id=eb9f8732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9f8732",
  null
  
)

export default component.exports